import { FullStory, init, isInitialized } from '@fullstory/browser';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';

import { type RootState } from '@editor2/reducers/root';

interface IdentityPayload {
	sub?: number | string;
	extra?: {
		userInfo?: {
			userId?: number | string;
			fullstoryProperties?: {
				soomoUserType_str?: string;
				soomoUserRoles_str?: string;
			};
		};
	};
}

export const useFullStoryInitialize = (isCourseLoaded: boolean) => {
	const accessToken = useSelector((state: RootState) => state.jwt.token);
	const token = accessToken || localStorage.getItem('accessToken');

	useEffect(() => {
		if (!isCourseLoaded || isInitialized()) return;

		const orgId = import.meta.env.VITE_FULLSTORY_ORG_ID?.trim();

		if (!orgId) return;

		try {
			init({ orgId });
		} catch (error) {
			console.error('[FullStory] Initialization failed:', error);
		}
	}, [isCourseLoaded]);

	useEffect(() => {
		if (!isCourseLoaded || !token || !import.meta.env.VITE_FULLSTORY_ORG_ID?.trim() || !isInitialized()) return;

		try {
			const payload = jwtDecode<IdentityPayload>(token);
			const userInfo = payload.extra?.userInfo;
			const userId = userInfo?.userId ?? payload.sub;
			if (userId == null || String(userId).trim() === '') return;

			const identity = {
				uid: String(userId),
				properties: {
					soomoUserType_str: userInfo?.fullstoryProperties?.soomoUserType_str,
					soomoUserRoles_str: userInfo?.fullstoryProperties?.soomoUserRoles_str
				}
			};

			FullStory('setIdentity', identity);
		} catch {
			console.warn('[FullStory] Could not set user identity.');
		}
	}, [isCourseLoaded, token]);
};
